module.exports = __webpack_public_path__ + "img/N220-1-EN.52ae02d1.png";